import {
  shallowRef,
} from 'vue';

/** The parts of the app layout that Alt/⌥ + 1, 2 and 3 switch between. */
export enum EKeyboardArea {
  AppNavigation = 'app-navigation',
  PageNavigation = 'page-navigation',
  PageContent = 'page-content',
}

export const KEYBOARD_AREA_ATTRIBUTE = 'data-keyboard-area';

/** The area that the keys apply to while nothing in an area has the focus: the one focused or clicked last. */
export const activeKeyboardArea = shallowRef(EKeyboardArea.PageContent);

/** The area of the element. Everything outside the navigation areas, e.g. the header and dialogs, counts as content. */
export function findKeyboardArea(element: Element): EKeyboardArea {
  const areaElement = element.closest(`[${KEYBOARD_AREA_ATTRIBUTE}]`);
  const area = areaElement?.getAttribute(KEYBOARD_AREA_ATTRIBUTE) as EKeyboardArea | undefined;
  return area ?? EKeyboardArea.PageContent;
}

export function findKeyboardAreaElement(area: EKeyboardArea): HTMLElement | undefined {
  return Array.from(document.querySelectorAll<HTMLElement>(`[${KEYBOARD_AREA_ATTRIBUTE}="${area}"]`))
    .find((areaElement) => areaElement.checkVisibility());
}
